<template>
  <Modal
    data-testid="client-resource-modal"
    :show="show"
    role="alertdialog"
    size="5xl"
  >
    <form
      class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
    >
      <slot>
        <ModalHeader v-text="'Klient'" />
        <ModalContent>
          <p class="leading-normal">
            <div class="well" bis_skin_checked="1">
              <div class="flex flex-wrap " bis_skin_checked="1">
                <template v-for="field in client.fields">
                  <div v-if="(field.attribute != 'lock') && (field.component != 'id-field')" class="md:w-1/6 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                      <strong>{{field.name}}:</strong><br> 
                      
                        <span v-html="field.displayAs || field.displayedAs || field.value"></span>
                  </div>
                </template>
                  <!-- {{field.displayAs || field.displayedAs || field.value}} -->
                 <!--  <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                      <strong>Kontakt:</strong><br> 518100284
                  </div>
                  <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                      <strong>Typ:</strong><br> 
                                      <span style="color:green;">uczciwy</span>
                              </div>
                  <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                      <strong>Adres:</strong><br> ogrodowa31/3
                  </div>
                  <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                      <strong>Uwagi:</strong><br> brak
                  </div>
                  <div class="md:w-1/5 pr-4 pl-4 sm:w-1/2 pr-4 pl-4" bis_skin_checked="1">
                      <strong>Data dodania:</strong><br> 2018-04-26 10:53:37<br>    
                  </div> -->
              </div>
          </div>
          </p>
        </ModalContent>
      </slot>

      <ModalFooter>
        <div class="ml-auto">
          <LinkButton
            type="button"
            data-testid="cancel-button"
            dusk="cancel-delete-button"
            @click.prevent="handleClose"
            class="mr-3"
          >
            {{ __('Cancel') }}
          </LinkButton>

          
        </div>
      </ModalFooter>
    </form>
  </Modal>
</template>

<script>
import startCase from 'lodash/startCase'

export default {
  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },

    client: {
      default: null,
    },
  },

  data: () => ({
    working: false,
  }),

  methods: {
    handleClose() {
      this.$emit('close')
      this.working = false
    },

    handleConfirm() {
      this.$emit('confirm')
      this.working = true
    },
    
  },

  /**
   * Mount the component.
   */
  mounted() {
    this.$nextTick(() => {
      // this.$refs.confirmButton.button.focus()
    })
  },

  computed: {
    uppercaseMode() {
      return startCase(this.mode)
    },

  },
}
</script>
